import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { WEEKDAYS, daysOfWeekShort } from './constants';

export type Props = {
  value: Weekday[];
  onChange: (value: Weekday) => void;
};

const DaysContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
`;

const DayButton = styled(Button)<{ isActive: boolean }>`
  text-transform: capitalize;
  margin-inline-end: 4px;
  margin-block: 12px;
  padding: 0;
  width: 100%;

  ${({ isActive }) =>
    isActive
      ? css`
          border: 1px solid ${colors.wolt100};
        `
      : css`
          border: 1px solid ${cbSemanticCssVars.borderPrimary};
          color: ${cbSemanticCssVars.textPrimary};
        `}
  &:last-child {
    margin-inline-end: 0;
  }
`;

const WeekdaySelect = ({ value: selectedDays, onChange }: Props) => {
  return (
    <DaysContainer>
      {WEEKDAYS.map((dayOfWeek, dayOfWeekIndex) => {
        const dayIsSelected = selectedDays.includes(dayOfWeek);

        const buttonVariant = dayIsSelected ? 'lightBlue' : 'white';

        return (
          <DayButton
            key={dayOfWeekIndex}
            variant={buttonVariant}
            size="small"
            isActive={dayIsSelected}
            onClick={() => onChange(dayOfWeek)}
            data-test-id={`${dayOfWeek}-button`}
          >
            <FormattedMessage id={daysOfWeekShort[dayOfWeek].id} defaultMessage={daysOfWeekShort[dayOfWeek].default} />
          </DayButton>
        );
      })}
    </DaysContainer>
  );
};

export default WeekdaySelect;
